"use client";

import { useState } from "react";
import "../assets/css/authpage.min.css";
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { toast, ToastContainer } from 'react-toastify';
import TwoFactorAuthImage from './../assets/img/Two-factor-authentication-pana.svg';

export default function AuthPage () {
    const [loginFormData, setLoginFormData] = useState({
        email: "",
        password: "",
    });

    const navigate = useNavigate();

    const handleLoginFormSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append("email", loginFormData.email);
        data.append("password", loginFormData.password);

        try {
            const response = await fetch("https://leapatinternational.com/admin/api/v1/web_login.php", {
                method: "POST",
                body: data,
            });

            const result = await response.json();

            if (result.status === "success") {
                toast.success("Login successful!");
                Cookies.set('isUserIn', 'true', { expires: 7 }); // Expires in 7 days
                Cookies.set('userId', result.data.id, { expires: 7 }); // Store email in cookie
                navigate('/');
                window.location.reload();
            } else {
                toast.error(result.message || "Login failed");
            }
        } catch (err) {
            console.error("Error:", err);
            toast.error("Network error. Please try again.");
        }
    };

    const handleLoginInputChange = (e) => {
        setLoginFormData({
            ...loginFormData,
            [e.target.name]: e.target.value,
        });
    };

    return (
        <div className="auth-page-wrapper">
            <div className="flex-row">
                {/* Login Section - Left Side */}
                <div className="half-column ">
                    <img src={TwoFactorAuthImage} alt="log in page" style={{
                        height: "600px",
                        "@media (min-width: 992px)": {
                            marginLeft: "50px"
                        }
                    }} />
                </div>
                <div className="half-column mt-5">
                    <div className="form-wrapper">
                        <div className="form-header">
                            <h2 className="page-title">Welcome Back</h2>
                            <p className="page-subtitle">Sign in to your account</p>
                        </div>

                        <form onSubmit={handleLoginFormSubmit} className="auth-form">
                            <div className="input-group">
                                <label htmlFor="loginEmail" className="field-label">
                                    Email Address
                                </label>
                                <input
                                    type="email"
                                    id="loginEmail"
                                    name="email"
                                    className="input-field"
                                    placeholder="Enter your email address"
                                    value={loginFormData.email}
                                    onChange={handleLoginInputChange}
                                    required
                                />
                            </div>

                            <div className="input-group">
                                <label htmlFor="loginPassword" className="field-label">
                                    Password
                                </label>
                                <input
                                    type="password"
                                    id="loginPassword"
                                    name="password"
                                    className="input-field"
                                    placeholder="Enter your password"
                                    value={loginFormData.password}
                                    onChange={handleLoginInputChange}
                                    required
                                />
                            </div>

                            <button type="submit" className="btn-signin rounded-3 full-width">
                                Sign In
                            </button>
                            <p className="d-flex justify-content-center mt-3">Don't have an account? <a href="/sign-up">Sign up</a></p>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}
